import styled from "styled-components/macro";
import { COLORES } from "../../constants";

export const DeleteFilter = styled.span`
  cursor: pointer;
`;

export const Container = styled.div`
  font-size: 0.8rem;
  padding: 1rem;
  background-color: ${COLORES.BACKGROUND};
  button {
    cursor: pointer;
    width: 100%;
  }
  .tableButton {
    backgroundcolor: transparent;
    color: #0d6efd;
    textdecoration: underline;
    padding: 0;
    border: none;
    background: none;
  }
  .tableButton:hover {
    color: #0a58ca;
  }
`;
